import React from 'react'

export default function home() {
  return (
    <section className='home-section'>
      <div className='container flex'>
        <div className='home-intro'>
          <h2 className='sub-heading'> SO, YOU WANT TO TRAVEL TO </h2>
          <h1 className='heading'> SPACE </h1>
          <p className='para'> Let’s face it; if you want to go to space, you might as well genuinely go to outer space and not hover kind of on the edge of it. Well sit back, and relax because we’ll give you a truly out of this world experience! </p>
        </div>
        <div className='home-graphics-container' >
          <div className='home-graphics'>
            explore 
          </div>
        </div>
      </div>
    </section>
  )
}